.transparent {
  opacity: 0%;
}
